<template>
  <section>
    <Equipment no-title />
  </section>
</template>
<script>
const name = "SolutionsEquipment"

import Equipment from '@/components/Equipment.vue'

export default {
  name,
  components: {
    Equipment
  }
}

</script>
